import { isDateStr } from './index'
// 需要转码的表单接口。一般可以允许输入特殊字符的字段
const NEED_TRANSCODE_FORM_INTERFACE = [
  {
    url: '/app-coproduction/production-plan/saveInComingPlan',
    method: 'post'
  },
  {
    url: '/app-coproduction/production-plan/additionalPlan',
    method: 'post'
  },
  {
    url: '/app-coproduction/production-plan',
    method: 'put'
  },
  {
    url: '/app-coproduction/production-plan',
    method: 'post'
  },
  {
    url: '/masterlink-cps-product/product',
    method: 'post'
  },
  {
    url: '/masterlink-cps-product/product',
    method: 'put'
  }
]

// 需要转码的字段，编号、名称、单号这些
const NEED_TRANSCODE_FIELDS = ['extend1', 'extend2', 'extend3', 'extend4', 'extend5']

// 拿到需要转码的列表接口  模糊查询
const NEED_TRANSCODE_LIST_INTERFACE = [
  {
    url: 'production-plan/page',
    method: 'post'      
  },
  {
    url: 'product/page',
    method: 'post'   
  },
  {
    url: 'production-plan',
    method: 'get' 
  }
]

const decodeObj = (obj) => {
  try {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'string') {
        obj[key] = decodeURI(obj[key])
      }
    }
  } catch (e) {
    console.log('e', e)
  }
  return obj
}

// 提交表单做转码
export const encodeFormParam = (config: any) => {
  NEED_TRANSCODE_FORM_INTERFACE.forEach(res => {
    if (res.url === config.url && res.method === config.method && config.data) { 
      const temp = JSON.parse(config.data)
      for (const key in temp) {
        if (NEED_TRANSCODE_FIELDS.includes(key) && temp[key] && typeof temp[key] === 'string' && !isDateStr(temp[key])) {
          temp[key] = encodeURI(temp[key])
        }
      }
      config.data = JSON.stringify(temp)
    } 
  })
  if (config.url.includes('app-coproduction/production-plan/page') && config.url.includes('current')) { //  高级查询也需要
    const temp = JSON.parse(config.data)
    for (const key in temp) {
        if (key === 'param' && Object.keys(temp[key]).length > 0) { // 有可能是高级搜索的模糊查询
            console.log('ytt', temp)
            for(const re in temp[key]) {
                if (re.includes('extend')) {
                  temp[key][re] = encodeURI(temp[key][re])
                }
            }
        }
    }
    config.data = JSON.stringify(temp)
  }
  return config
}

// 接收列表做解码
export const decodeList = (response) => {
  NEED_TRANSCODE_LIST_INTERFACE.forEach(res => {
    if (response.config && response.config.url && response.config.url.includes(res.url)
      && response.config.method === res.method && response.data && response.data.data) {
     if (Array.isArray(response.data.data.records)) {
        response.data.data.records.forEach(re => {
          re = decodeObj(re)
        })
      } else if (response.data.data) { //单个
        response.data.data = decodeObj(response.data.data)
      } 
    }
  })
  return response
}